import { render, staticRenderFns } from "./fullscreen-modal.vue?vue&type=template&id=1ca83bd0&scoped=true"
import script from "./fullscreen-modal.vue?vue&type=script&lang=js"
export * from "./fullscreen-modal.vue?vue&type=script&lang=js"
import style0 from "./fullscreen-modal.vue?vue&type=style&index=0&id=1ca83bd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca83bd0",
  null
  
)

export default component.exports